export const SURFACE_KEYS = ['primary'] as const;
export type Surface = (typeof SURFACE_KEYS)[number];

export const mapSurfaceKey = (key?: string | null): Surface =>
	({ primary: 'primary' }[(key ?? 'inherit').toLowerCase() as keyof typeof SURFACE_KEYS] ?? 'inherit');
